export default "__VITE_ASSET__QoMw8nCu__"